import {
    CogIcon,
    Dropdown,
    DropdownItemLink,
    DropdownMenuItem,
    LogoutIcon,
    Pressable,
    useDropdownMenuClickCallback,
    VStack
} from "@hosttools/frontend";
import type {DropdownItemType, IMenuProps} from "@hosttools/frontend";
import type React from "react";
import {memo, useCallback, useMemo} from "react";

import AvatarProfile from "./AvatarProfile";
import MenuItem from "./MenuItem";

type Props = {
    showMenuOnly?: boolean;
};

const MenuProfile: React.FC<Props> = ({showMenuOnly}) => {
    const handleClickMenu = useDropdownMenuClickCallback();

    const triggerUserProfile: IMenuProps["trigger"] = useCallback(props => {
        return (
            <Pressable accessibilityLabel="User profile" testID="user-profile" {...props}>
                <AvatarProfile />
            </Pressable>
        );
    }, []);

    const menuDisplay: DropdownItemType[] = useMemo(
        () => [
            {
                Icon: CogIcon,
                label: "Settings",
                link: "/settings",
                type: "internal",
                testID: "menu-item-settings"
            },
            {
                Icon: LogoutIcon,
                label: "Logout",
                link: "/logout",
                type: "external",
                target: "_self",
                testID: "menu-item-logout"
            }
        ],
        []
    );

    if (showMenuOnly) {
        return (
            <VStack className="px-5">
                {menuDisplay.map(menu => {
                    return <MenuItem key={menu.label} menu={menu} onClickMenu={handleClickMenu} />;
                })}
            </VStack>
        );
    }

    return (
        <Dropdown className="min-w-64" placement="bottom right" trigger={triggerUserProfile}>
            <DropdownMenuItem disabled className="px-3 py-2 border-b-0">
                <AvatarProfile showName />
            </DropdownMenuItem>
            {menuDisplay.map(menu => {
                return (
                    <DropdownMenuItem
                        key={menu.label}
                        testID={menu.testID}
                        onPress={() => handleClickMenu(menu)}
                    >
                        <DropdownItemLink size="sm" {...menu} />
                    </DropdownMenuItem>
                );
            })}
        </Dropdown>
    );
};

export default memo(MenuProfile);
